'use client';

import React from 'react';
import { Box, Text, HStack, VStack } from '@skin-seoul/design-system';
import LucideIcon from '@/components/ui/LucideIcon';
import { overlay } from 'overlay-kit';
import BenefitsModal from './BenefitsModal';
import { Country, useRegionCurrency, US_CUSTOMERS_BENEFITS, NON_US_CUSTOMERS_BENEFITS } from '@skin-seoul/service';
const ProductBenefits = () => {
  const {
    country
  } = useRegionCurrency();
  const handleBenefitClick = (benefitId: string) => {
    overlay.open(({
      isOpen,
      close
    }) => <BenefitsModal isOpen={isOpen} onClose={close} expandedBenefitId={benefitId} />);
  };
  return <Box width="100%" data-sentry-element="Box" data-sentry-component="ProductBenefits" data-sentry-source-file="ProductBenefits.tsx">
      <Box background="white" paddingY={{
      base: 4,
      tablet: 4
    }} paddingX={{
      base: 4,
      tablet: 4
    }} data-sentry-element="Box" data-sentry-source-file="ProductBenefits.tsx">
        <VStack gap={6} width="100%" alignItems="flex-start" data-sentry-element="VStack" data-sentry-source-file="ProductBenefits.tsx">
          <Text textStyle="label.large" color="neutral.800" fontWeight="medium" data-sentry-element="Text" data-sentry-source-file="ProductBenefits.tsx">
            Only at SkinSeoul
          </Text>
          <VStack gap={3} width="100%" alignItems="flex-start" data-sentry-element="VStack" data-sentry-source-file="ProductBenefits.tsx">
            {(country === Country.UnitedStates ? US_CUSTOMERS_BENEFITS : NON_US_CUSTOMERS_BENEFITS).map((benefit, index) => <HStack key={index} gap={2} alignItems="center" width="auto" cursor="pointer" _hover={{
            opacity: 0.8
          }} transition="opacity 0.2s" paddingY={1}>
                <LucideIcon name={benefit.icon as 'ShieldCheck' | 'PercentCircle' | 'PackageCheck'} size="sm" color="primary.400" />
                <Text textStyle="label.medium" color="primary.400" flex={1} onClick={() => handleBenefitClick(benefit.id)}>
                  {benefit.label}
                </Text>
              </HStack>)}
          </VStack>
        </VStack>
      </Box>
    </Box>;
};
export default ProductBenefits;